/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HistoricalWalletsResponse } from "./HistoricalWalletsResponse.ts";
import type { HTTPValidationError } from "./HTTPValidationError.ts";

export const getHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsNetworkEnum =
	{
		REGTEST: "REGTEST",
		MAINNET: "MAINNET",
	} as const;

export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsNetworkEnum =
	(typeof getHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsNetworkEnum)[keyof typeof getHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsNetworkEnum];

export const getHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsGranularityEnum =
	{
		daily: "daily",
		weekly: "weekly",
	} as const;

export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsGranularityEnum =
	(typeof getHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsGranularityEnum)[keyof typeof getHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsGranularityEnum];

export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParams =
	{
		/**
		 * @type string
		 */
		network: GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsNetworkEnum;
		/**
		 * @description Start date for historical data (YYYY-MM-DD)
		 * @type string, date
		 */
		start_date: string;
		/**
		 * @description End date for historical data (YYYY-MM-DD)
		 * @type string, date
		 */
		end_date: string;
		/**
		 * @description Granularity of data points
		 * @default "daily"
		 * @type string | undefined
		 */
		granularity?: GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParamsGranularityEnum;
	};

/**
 * @description Successful Response
 */
export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGet200 =
	HistoricalWalletsResponse;

/**
 * @description Validation Error
 */
export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGet422 =
	HTTPValidationError;

export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryResponse =
	GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGet200;

export type GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQuery = {
	Response: GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGet200;
	QueryParams: GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGetQueryParams;
	Errors: GetHistoricalActiveWalletsV1StatsHistoricalActiveWalletsGet422;
};
